<label class="form-option-label" [for]="labelFor">
  <span><ng-content></ng-content></span>
</label>
